// 课堂派学生课程学习
export default [
    {
      path: '/learningCardInfo',
      name: '畅学卡',
      component: () => import(/* webpackChunkName: "KtpStudentHome" */ '@/views/Home/ktpStudentHome/learningCardInfo.vue')
    },
    {
      path: '/courseInfo',
      name: '课程详情',
      component: () => import(/* webpackChunkName: "CourseInfo" */ '@/views/Home/ktpStudentHome/courseInfo.vue')
    },
    {
      path: '/classification',
      name: '课程分类',
      component: () => import(/* webpackChunkName: "Classification" */ '@/views/Home/ktpStudentHome/classification.vue')
    },
    {
      path: '/studentMyCourse',
      name: '我的课程',
      component: () => import(/* webpackChunkName: "StudentMyCourse" */ '@/views/Home/ktpStudentHome/myCourse.vue')
    },
    {
      path: '/growingProcess',
      name: '成长计划',
      component: () => import(/* webpackChunkName: "GrowingProcess" */ '@/views/Home/ktpStudentHome/growingProcess.vue')
    },
    {
      path: '/growingProcessInfo',
      name: '成长计划详情',
      component: () => import(/* webpackChunkName: "GrowingProcessInfo" */ '@/views/Home/ktpStudentHome/growingProcessInfo.vue')
    },
    {
      path: '/traincampusinfo',
      name: '训练营',
      component: () => import(/* webpackChunkName: "CourseInfo" */ '@/views/Home/ktpStudentHome/trainCampusInfo.vue')
    },
    {
      path: '/trainCampusPaySuccess',
      name: '训练营支付成功',
      component: () => import(/* webpackChunkName: "CourseInfo" */ '@/views/Home/ktpStudentHome/trainCampusPaySuccess.vue')
    },
    {
      path: '/discover',
      name: '发现',
      component: () => import(/* webpackChunkName: "CourseInfo" */ '@/views/Home/ktpStudentHome/discover.vue')
    },
    {
      path: '/adCategoryContent',
      name: '课程分类详情',
      component: () => import(/* webpackChunkName: "CourseInfo" */ '@/views/Home/ktpStudentHome/adCategoryContent.vue')
    },
    {
      path: '/final',
      name: '大学不挂科',
      component: () => import(/* webpackChunkName: "CourseInfo" */ '@/views/Home/ktpStudentHome/discover.vue')
    },
]
